import { render, staticRenderFns } from "./WalletCardEmergencyContact.vue?vue&type=template&id=71a386cc&"
import script from "./WalletCardEmergencyContact.vue?vue&type=script&lang=js&"
export * from "./WalletCardEmergencyContact.vue?vue&type=script&lang=js&"
import style0 from "./WalletCardEmergencyContact.vue?vue&type=style&index=0&id=71a386cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports